























































import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import { CompanyStoreHelper, NotificationStoreHelper } from '../../mixins';
import { TrackingService } from '../../api';
import { PointsOfInterest } from '../../models';
import Input from "../Input.vue";

@Component({
    components:{
        Input
    }
})
export default class AddPoint extends Mixins(CompanyStoreHelper, NotificationStoreHelper) {
    @Prop({ default: false }) visible: boolean;
    @Prop({ default: false }) edit: boolean;
    @Prop() positionX: number;
    @Prop() positionY: number;
    @Prop() latitude: number;
    @Prop() longitude: number;
    @Prop() editDescription: string;
    @Prop() pointId: string | number;
    @Prop() pointToEdit: PointsOfInterest | null;
    minRules = [v => !!v || 'valor requerido'];
    validCondition: boolean = false;
    loading: boolean = false;
    description: string = '';

    handleSubmit(): void {
        if (!this.iqualZero && !this.loading) {
            if (this.edit) {
                this.editMarker();
            } else {
                this.saveMarker();
            }
        }
    }

    updateDescription(value){
        this.description = value;
    }

    get iqualZero(): boolean {
        return this.latitude === 0 && this.longitude === 0 && !this.edit;
    }

    saveMarker(): void {
        this.loading = true;
        TrackingService.postPointsOfInterest(
            { latitude: this.latitude, longitude: this.longitude },
            this.$_getSelectedCompanyById as string,
            this.description
        )
            .then(response => {
                this.loading = false;
                if (response['status'] === 200 || response['status'] === 204) {
                    this.addPoint(response['data']);
                    this.$_showAddPointOfInterest('Punto de interés añadido correctamente');
                } else {
                    this.$_errorAddPointOfInterest('Problema añadiendo Punto de interés');
                    this.addPoint(null);
                }
            })
            .catch(error => {
                this.loading = false;
                if (error && error.response && error.response.data && error.response.data.message) {
                    this.$_errorAddPointOfInterest(error.response.data.message);
                } else {
                    this.$_errorAddPointOfInterest('Problema añadiendo Punto de interés');
                }
                this.addPoint(null);
            });
    }

    editMarker(): void {
        this.loading = true;
        TrackingService.patchPointsOfInterest(
            {
                point_of_interest_id: this.pointId,
                description: this.description,
                point: { latitude: this.latitude, longitude: this.longitude }
            },
            this.pointId
        )
            .then(response => {
                this.loading = false;
                if (response['status'] === 200 || response['status'] === 204) {
                    this.editPoint({
                        point_of_interest_id: this.pointId,
                        description: this.description,
                        point: { lat: this.latitude, lng: this.longitude }
                    });
                    this.$_showAddPointOfInterest('Punto de interés editado correctamente');
                } else {
                    this.$_errorAddPointOfInterest('Problema editando Punto de interés');
                    this.editPoint(null);
                }
            })
            .catch(error => {
                this.loading = false;
                if (error && error.message) {
                    this.$_errorAddPointOfInterest(error.message);
                } else {
                    this.$_errorAddPointOfInterest('Problema editando Punto de interés');
                }
                this.editPoint(null);
            });
    }

    get form(): HTMLFormElement {
        return this.$refs.form as HTMLFormElement;
    }

    get descriptionInput(): HTMLInputElement {
        return this.$refs.description as HTMLInputElement;
    }

    reset() {
        this.form.reset();
    }
    resetValidation() {
        this.form.resetValidation();
    }

    clear(): void {}

    @Emit()
    cancelPoint(point: PointsOfInterest | null) {}

    @Emit()
    addPoint(point: PointsOfInterest | null) {}

    @Emit()
    editPoint(point: PointsOfInterest | null) {}

    @Watch('visible')
    observerVisible(newValue: boolean): void {
        if (newValue) {
            this.setFocusAndDescription();
        } else {
            this.description = '';
            this.reset();
            this.resetValidation();
        }
    }

    @Watch('positionX')
    observerPositionX(): void {
        this.setFocusAndDescription();
        this.resetValidation();
    }
    @Watch('positionY')
    observerPositionY(): void {
        this.setFocusAndDescription();
        this.resetValidation();
    }

    setFocusAndDescription(): void {
        setTimeout(() => this.descriptionInput.focus(), 100);
        if (this.edit) {
            this.description = this.editDescription;
        }
    }
}
